export const emotionsAndFeelings = [
  {
    word: "happy",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    synonyms: ["joyful", "cheerful", "content"],
    example: "She felt happy when she saw her friends.",
    definition: "Feeling or showing pleasure or contentment."
  },
  {
    word: "sad",
    image: "https://images.unsplash.com/photo-1487412912498-0447578fcca8",
    synonyms: ["unhappy", "sorrowful", "downcast"],
    example: "He was sad after hearing the bad news.",
    definition: "Feeling unhappy or sorrowful."
  },
  {
    word: "angry",
    image: "https://images.unsplash.com/photo-1607864151114-1cc59c89b2c3",
    synonyms: ["mad", "furious", "irritated"],
    example: "She got angry when they broke her phone.",
    definition: "Feeling strong displeasure or rage."
  },
  {
    word: "excited",
    image: "https://images.unsplash.com/photo-1504198453319-5ce911bafcde",
    synonyms: ["thrilled", "eager", "delighted"],
    example: "The kids were excited about the trip.",
    definition: "Feeling very enthusiastic and happy."
  },
  {
    word: "nervous",
    image: "https://images.unsplash.com/photo-1549921296-3a6b450e979e",
    synonyms: ["anxious", "worried", "uneasy"],
    example: "He felt nervous before the interview.",
    definition: "Worried or afraid about something."
  },
  {
    word: "surprised",
    image: "https://images.unsplash.com/photo-1581090700227-1e8d743c5edb",
    synonyms: ["shocked", "amazed", "astonished"],
    example: "She was surprised to see her old friend.",
    definition: "Feeling sudden wonder or amazement."
  },
  {
    word: "bored",
    image: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3",
    synonyms: ["uninterested", "tired", "restless"],
    example: "He got bored during the long meeting.",
    definition: "Feeling tired and uninterested."
  },
  {
    word: "confused",
    image: "https://images.unsplash.com/photo-1585842212787-8d0ef12e6b0a",
    synonyms: ["puzzled", "uncertain", "bewildered"],
    example: "She looked confused by the instructions.",
    definition: "Unable to understand or think clearly."
  },
  {
    word: "grateful",
    image: "https://images.unsplash.com/photo-1511988617509-a57c8a288659",
    synonyms: ["thankful", "appreciative", "pleased"],
    example: "I am very grateful for your help.",
    definition: "Feeling thankful for something."
  },
  {
    word: "lonely",
    image: "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc",
    synonyms: ["isolated", "alone", "desolate"],
    example: "He felt lonely after moving to a new city.",
    definition: "Feeling sad because of being alone."
  },
  {
    word: "embarrassed",
    image: "https://images.unsplash.com/photo-1623776058899-d12d6aa28b2d",
    synonyms: ["ashamed", "awkward", "uncomfortable"],
    example: "She felt embarrassed when she forgot his name.",
    definition: "Feeling awkward or ashamed."
  },
  {
    word: "confident",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c",
    synonyms: ["self-assured", "secure", "bold"],
    example: "He felt confident during the speech.",
    definition: "Feeling sure about your abilities."
  },
  {
    word: "jealous",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b9642738",
    synonyms: ["envious", "resentful", "possessive"],
    example: "She felt jealous of her friend’s success.",
    definition: "Feeling resentment or envy toward someone."
  },
  {
    word: "hopeful",
    image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853",
    synonyms: ["optimistic", "positive", "encouraged"],
    example: "They were hopeful about the future.",
    definition: "Feeling that something good will happen."
  },
  {
    word: "proud",
    image: "https://images.unsplash.com/photo-1530133532239-4f4d83a7bde4",
    synonyms: ["pleased", "honored", "dignified"],
    example: "He was proud of his team’s performance.",
    definition: "Feeling pleasure or satisfaction about achievement."
  },
  {
    word: "shy",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
    synonyms: ["timid", "bashful", "introverted"],
    example: "The shy boy avoided eye contact.",
    definition: "Nervous and uncomfortable around others."
  },
  {
    word: "calm",
    image: "https://images.unsplash.com/photo-1485560892063-dbbd6f6b6bce",
    synonyms: ["peaceful", "relaxed", "quiet"],
    example: "He stayed calm during the emergency.",
    definition: "Not feeling angry or anxious."
  },
  {
    word: "guilty",
    image: "https://images.unsplash.com/photo-1611930021805-4273b4e14e68",
    synonyms: ["ashamed", "remorseful", "regretful"],
    example: "She felt guilty for lying.",
    definition: "Feeling bad about doing something wrong."
  },
  {
    word: "anxious",
    image: "https://images.unsplash.com/photo-1603415526960-f8fbd2185442",
    synonyms: ["nervous", "worried", "uneasy"],
    example: "He was anxious about the exam results.",
    definition: "Feeling worried or uneasy."
  },
  {
    word: "relieved",
    image: "https://images.unsplash.com/photo-1531259683007-016a7b628fc9",
    synonyms: ["comforted", "reassured", "at ease"],
    example: "She felt relieved when the storm passed.",
    definition: "Feeling less worried or stressed."
  },
  {
    word: "frustrated",
    image: "https://images.unsplash.com/photo-1593651366363-2c8a8f8cd0b7",
    synonyms: ["annoyed", "discouraged", "upset"],
    example: "He felt frustrated by the slow internet.",
    definition: "Feeling upset because of difficulties."
  },
  {
    word: "overwhelmed",
    image: "https://images.unsplash.com/photo-1585842212787-8d0ef12e6b0a",
    synonyms: ["stressed", "burdened", "swamped"],
    example: "She felt overwhelmed with too much work.",
    definition: "Feeling too much to handle or control."
  },
  {
    word: "curious",
    image: "https://images.unsplash.com/photo-1529635913481-50e1d4d2c4dd",
    synonyms: ["inquisitive", "interested", "questioning"],
    example: "The child was curious about everything.",
    definition: "Eager to know or learn something."
  },
  {
    word: "insecure",
    image: "https://images.unsplash.com/photo-1511407397940-d57f68e81203",
    synonyms: ["unsure", "uncertain", "doubtful"],
    example: "He felt insecure about his accent.",
    definition: "Lacking confidence or assurance."
  },
  {
    word: "loving",
    image: "https://images.unsplash.com/photo-1511988617509-a57c8a288659",
    synonyms: ["affectionate", "caring", "kind"],
    example: "She gave her child a loving hug.",
    definition: "Showing strong affection and care."
  }
];
